import { useNavigate } from "react-router-dom";
import { FormikProps } from "formik";
import { Button, Grid } from "../../../components";

interface StepNavigationProps<T>  {
  activeStep: number;
  setActiveStep: (step: number | ((prev: number) => number)) => void;
  formSteps: string[];
  formik: FormikProps<T>;
  loading: boolean;
}

export const StepNavigation = <T,>({
  activeStep,
  setActiveStep,
  formSteps,
  formik,
  loading
}: StepNavigationProps<T>) => {
  const navigate = useNavigate();

  const handleNextStep = async () => {
    const errors = await formik.validateForm();
    if (Object.keys(errors).length === 0) {
      if (activeStep === formSteps.length) {
        await formik.submitForm();
        navigate("/minhas-ofertas");
      } else {
        setActiveStep((prev) => prev + 1);
      }
    }
  };

  return (
    <Grid item xs={12} display="flex" justifyContent="space-between">
      {activeStep === 1 ? (
        <Button onClick={() => navigate("/minhas-ofertas")}>Voltar para Minhas Ofertas</Button>
      ) : (
        <Button onClick={() => setActiveStep((prev) => prev - 1)}>Voltar</Button>
      )}

      <Button
        onClick={handleNextStep}
        disabled={!formik.isValid || loading}
      >
        {activeStep === formSteps.length ? "Criar Oferta" : "Próximo"}
      </Button>
    </Grid>
  );
};

export default StepNavigation;
